// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { Statistic } from '~/components/common';
// Others
import { IObject } from '~/utils/interface/common';
import { useAppDispatch } from '~/utils/redux/hooks';
import { ITotalStatistic } from '~/utils/interface/statistics';
import { TotalStatisticEnum } from '~/utils/enum/common';
import { getTotalStatistic } from '~/thunks/statistic/statisticThunk';
// Styles, images, icons
import styles from './HeaderStatistic.module.scss';
import { icons, images } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const HeaderStatistic = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [dataStatistic, setDataStatistic] = useState<IObject>([]);
  //#endregion Declare State

  //#region Handle Function
  const getDataTotalStatistic = useCallback(() => {
    dispatch(getTotalStatistic())
      .unwrap()
      .then((resp) => {
        const data = resp?.data;
        if (!data) return;
        convertDataStatistic(data);
      })
      .catch((_error) => {})
      .finally(() => {});
  }, [dispatch]);

  //#region Implement Hook
  useEffect(() => {
    getDataTotalStatistic();
  }, [getDataTotalStatistic]);
  //#endregion Implement Hook

  //#endregion Handle Function

  const convertDataStatistic = (data: ITotalStatistic) => {
    const newData = Object.keys(data).reduce((acc, key) => {
      acc[key] = {
        quantity: data[key as keyof ITotalStatistic],
      };
      return acc;
    }, {} as IObject);

    setDataStatistic(newData);
  };

  //#endregion Handle Function

  return (
    <Box id='headerStatisticComponent' className={cx('headerStatisticContainer')}>
      <Statistic
        title={t('statistic_job')}
        data={dataStatistic[TotalStatisticEnum.TOTAL_JOBS]}
        icon={icons.commonIconJob}
        image={images.imgStatisticOne}
      />

      <Statistic
        title={t('statistic_estimate')}
        data={dataStatistic[TotalStatisticEnum.TOTAL_ESTIMATES]}
        icon={icons.commonIconEstimate}
        image={images.imgStatisticTwo}
      />
    </Box>
  );
};

export default HeaderStatistic;
